import React from 'react'
import {
  HistogramViewItem,
  processHistogramViewItem,
  VrHistogramView
} from '../vr-histogram-view'
import { HistogramViewProps } from '../../shared'
import {
  VulnerabilitySeverityBadge,
  Severity
} from '../../../../../vulnerability-severity'
import { VulnerabilitySeverityThermometer } from '../../../../../thermometer/vuln-severity-thermometer'
import {
  VulnerabilitySeverity,
  VulnerabilitySeverityRegistry
} from '../../../../../../graphql/schema/shared'

const e2eTestIdPrefix = 'value-reporting-vulnerabilities-severity-breakdown'

/**
 * The histogram view badge
 */
function ViewBadge({ item }: HistogramViewItem) {
  const severity = item as VulnerabilitySeverity

  return (
    <VulnerabilitySeverityBadge
      e2eTestId={`${e2eTestIdPrefix}-badge-${severity}`}
      severity={Severity.fromName(severity)}
      key={severity}
    />
  )
}

/**
 * The histogram view thermometer
 */
function ViewThermometer({ item, ratio }: HistogramViewItem) {
  const severity = item as VulnerabilitySeverity

  return (
    <VulnerabilitySeverityThermometer
      e2eTestId={`${e2eTestIdPrefix}-thermometer-${severity}`}
      key={severity}
      severity={severity}
      ratio={ratio}
    />
  )
}

/**
 * This is the view for vulnerability severities within the value reporting histogram module.
 */
export function HistogramViewSeverity({
  organizationUuid,
  selectedFacets,
  histogramType,
  data: { vulnerabilitySeverity }
}: HistogramViewProps) {
  return (
    <VrHistogramView
      organizationUuid={organizationUuid}
      selectedFacets={selectedFacets}
      histogramType={histogramType}
      e2eTestId={e2eTestIdPrefix}
      data={vulnerabilitySeverity}
      renderLabel={ViewBadge}
      renderThermometer={ViewThermometer}
      processSummary={processViewSummaryData}
    />
  )
}

/**
 * Processes a set of raw histogram data and converts it to sorted view items.
 */
export function processViewSummaryData(
  items: VulnerabilitySeverity[],
  counts: number[],
  ratios: number[]
): Array<HistogramViewItem> {
  return [
    VulnerabilitySeverityRegistry.CRITICAL,
    VulnerabilitySeverityRegistry.HIGH,
    VulnerabilitySeverityRegistry.MEDIUM,
    VulnerabilitySeverityRegistry.LOW,
    VulnerabilitySeverityRegistry.NOTE
  ].map((severity) => processHistogramViewItem(severity, items, counts, ratios))
}
